import { ReactNode, useMemo } from 'react'
import { lighten, Theme } from '@mui/material'
import { iconSetMaterial, themeQuartz } from 'ag-grid-community'
// import resolveConfig from 'tailwindcss/resolveConfig'
// import tailwind from '~root/tailwind.config.js'
import AgDataGridThemeContext from './AgDataGridThemeContext'

// const tailwindConfig = resolveConfig(tailwind)

interface AgDataGridThemeProviderProps {
  children: ReactNode
  theme: Theme
}

const AgDataGridThemeProvider = (props: AgDataGridThemeProviderProps) => {
  const { children, theme: muiTheme } = props
  // console.log('muiTheme:', muiTheme.palette)

  const theme = useMemo(() => {
    return themeQuartz.withPart(iconSetMaterial).withParams({
      // accentColor: '#F28922',
      accentColor: muiTheme.palette.primary.main,
      backgroundColor: muiTheme.palette.background.paper,
      // borderRadius: 4,
      borderColor: muiTheme.palette.divider,
      browserColorScheme: 'inherit',
      chromeBackgroundColor: {
        ref: 'foregroundColor',
        mix: 0.07,
        onto: 'backgroundColor',
      },
      fontFamily: {
        googleFont: 'Lato',
      },
      foregroundColor: muiTheme.palette.text.primary,
      headerBackgroundColor: muiTheme.palette.action.hover,
      headerFontSize: 14,
      iconSize: 16,
      oddRowBackgroundColor: lighten(muiTheme.palette.background.paper, 0.05),
      rowBorder: false,
      wrapperBorderRadius: 0,
    })
  }, [muiTheme])

  return (
    <AgDataGridThemeContext.Provider value={theme}>
      {children}
    </AgDataGridThemeContext.Provider>
  )
}

export default AgDataGridThemeProvider
